import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/Button";
import { useUIStore } from "@/stores/useUIStore";

export function StaleVersionBanner() {
  const { t } = useTranslation();
  const visible = useUIStore((s) => s.chunkRecoveryFailed);

  if (!visible) return null;

  return (
    <div
      role="alert"
      aria-live="assertive"
      className="fixed inset-x-0 top-0 z-[100] flex items-center gap-3 border-b border-warning-200 bg-warning-50 px-4 py-3 text-warning-800 shadow-sm dark:border-warning-700/40 dark:bg-warning-700/20 dark:text-warning-200"
    >
      <AlertTriangle className="h-5 w-5 shrink-0" />
      <div className="flex-1 text-sm">
        <p className="font-semibold">{t("error.staleVersion.title")}</p>
        <p className="text-warning-700 dark:text-warning-300">
          {t("error.staleVersion.description")}
        </p>
      </div>
      <Button
        size="sm"
        variant="secondary"
        onClick={() => window.location.reload()}
      >
        {t("error.staleVersion.refresh")}
      </Button>
    </div>
  );
}
